export const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) {
    console.log("Service Worker is not supported.");
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );


    return registration;
  } catch (error) {
    console.error("Service Worker registration failed:", error);
    return null;
  }
};